// @ts-strict-ignore
import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import FilterDropdown from 'components/filter-dropdown';
import FilterMenuItem from 'components/filter-dropdown/filter-menu-item';
import { Label } from 'components/typography';
import { FilterTopic } from 'pages/playlists';

export const CURATOR_OPTIONS = [
  { value: 'GUEST', label: 'Guest' },
  { value: 'EDITORIAL', label: 'TED' }
];

export const POPULAR_TOPICS_OPTIONS = [
  { name: 'Technology', slug: 'Technology' },
  { name: 'Entertainment', slug: 'Entertainment' },
  { name: 'Design', slug: 'Design' },
  { name: 'Business', slug: 'Business' },
  { name: 'Science', slug: 'Science' },
  { name: 'Global issue', slug: 'Global issue' }
];

type PlaylistsSearchFiltersProps = {
  setCurator: (curator: string | null) => void;
  addTopic: (topic: FilterTopic) => void;
  setModalOpen: () => void;
  topics: string[];
  curator: string[];
};

function PlaylistsSearchFilters({
  setCurator,
  addTopic,
  topics,
  curator,
  setModalOpen
}: PlaylistsSearchFiltersProps): React.ReactNode {
  const curatorSelectedValues = curator ? [...curator] : [];

  const topicsLowerCase = topics?.map(topic => topic.toLowerCase());

  const topicOptions = () => {
    return POPULAR_TOPICS_OPTIONS.map(item => {
      return (
        <FilterMenuItem
          key={item.name}
          value={item.name}
          text={item.name}
          selected={topicsLowerCase?.includes(item.name.toLowerCase())}
          onSelect={name =>
            addTopic({
              name: name as string,
              slug: name as string
            })
          }
        />
      );
    });
  };

  const curatorOptions = () => {
    return CURATOR_OPTIONS.map(item => {
      return (
        <FilterMenuItem
          key={item.value}
          value={item.value}
          text={item.label}
          selected={curatorSelectedValues[0] === item.value}
          onSelect={setCurator}
        />
      );
    });
  };

  return (
    <div className="md:flex md:items-center">
      <Label
        className="mb-3 block w-full md:mb-0 md:mr-6 md:inline-block md:w-auto xl:mr-8"
        aria-hidden
      >
        <FormattedMessage defaultMessage="Browse playlists:" />
      </Label>

      <div className="inline-flex">
        <div className="mr-5">
          <FilterDropdown
            selectedItems={topics}
            popoverLabel="Popular topics"
            menuLabel="Topics"
            seeAllOptionsText="See all topics"
            onSeeAllOptionsSelect={setModalOpen}
          >
            {topicOptions()}
          </FilterDropdown>
        </div>

        <FilterDropdown
          selectedItems={curatorSelectedValues}
          popoverLabel="Curator"
          menuLabel="Curator"
        >
          {curatorOptions()}
        </FilterDropdown>
      </div>
    </div>
  );
}

export default PlaylistsSearchFilters;
